import { render, staticRenderFns } from "./CustomTextArea.vue?vue&type=template&id=0cb4fbe0&scoped=true&"
import script from "./CustomTextArea.vue?vue&type=script&lang=js&"
export * from "./CustomTextArea.vue?vue&type=script&lang=js&"
import style0 from "./CustomTextArea.vue?vue&type=style&index=0&id=0cb4fbe0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4fbe0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cb4fbe0')) {
      api.createRecord('0cb4fbe0', component.options)
    } else {
      api.reload('0cb4fbe0', component.options)
    }
    module.hot.accept("./CustomTextArea.vue?vue&type=template&id=0cb4fbe0&scoped=true&", function () {
      api.rerender('0cb4fbe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/carbonclap/components/carbon-template/CustomTextArea.vue"
export default component.exports